
// "Damage" Types
import psychic from "../assets/img/damage/noun_Brain_1801606.png";
import force from "../assets/img/damage/noun_meteor_3639271.png";
import poison from "../assets/img/damage/noun_Poison_148845.png";
import acid from "../assets/img/damage/noun_Poison_3044.png";
import radiant from "../assets/img/damage/noun_sun_2327688.png";
import cold from "../assets/img/damage/noun_Cold_1421094.png";
import fire from "../assets/img/damage/noun_Fire_2898883.png";
import lightning from "../assets/img/damage/noun_Lightning_1419625.png";
import thunder from "../assets/img/damage/noun_thunder_3257231.png";
import healing from "../assets/img/damage/noun_Heart_341290.png";
import necrotic from "../assets/img/damage/noun_grim reaper_2337468.png";
import bludgeoning from "../assets/img/damage/noun_hit_776976.png";
import piercing from "../assets/img/damage/noun_hit_2350976.png";
import slashing from "../assets/img/damage/noun_Sword_715112.png";
// White "damage" types
import psychic_white from "../assets/img/damage/noun_Brain_1801606_white.png";
import force_white from "../assets/img/damage/noun_meteor_3639271_white.png";
import poison_white from "../assets/img/damage/noun_Poison_148845_white.png";
import acid_white from "../assets/img/damage/noun_Poison_3044_white.png";
import radiant_white from "../assets/img/damage/noun_sun_2327688_white.png";
import cold_white from "../assets/img/damage/noun_Cold_1421094_white.png";
import fire_white from "../assets/img/damage/noun_Fire_2898883_white.png";
import lightning_white from "../assets/img/damage/noun_Lightning_1419625_white.png";
import thunder_white from "../assets/img/damage/noun_thunder_3257231_white.png";
import healing_white from "../assets/img/damage/noun_Heart_341290_white.png";
import necrotic_white from "../assets/img/damage/noun_grim reaper_2337468_white.png";
import bludgeoning_white from "../assets/img/damage/noun_hit_776976_white.png";
import piercing_white from "../assets/img/damage/noun_hit_2350976_white.png";
import slashing_white from "../assets/img/damage/noun_Sword_715112_white.png";
// Dice
import crit_fail from "../assets/img/dice/d20_white_crit_fail.png";
import crit_success from "../assets/img/dice/d20_white_crit_success.png";
import d4 from "../assets/img/dice/d4_white.png";
import d6 from "../assets/img/dice/d6_white.png";
import d8 from "../assets/img/dice/d8_white.png";
import d10 from "../assets/img/dice/d10_white.png";
import d12 from "../assets/img/dice/d12_white.png";
import d100 from "../assets/img/dice/d100.png";
import d100_white from "../assets/img/dice/d100_white.png";
import d20 from "../assets/img/dice/d20_white.png";
import d4_black from "../assets/img/dice/d4_black.png";
import d6_black from "../assets/img/dice/d6_black.png";
import d8_black from "../assets/img/dice/d8_black.png";
import d10_black from "../assets/img/dice/d10_black.png";
import d12_black from "../assets/img/dice/d12_black.png";
import d100_black from "../assets/img/dice/d100.png";
// Other
import circle from "../assets/img/circle.png";
import voice_white from "../assets/img/Voice_white.png";

// "Damage" Types
export const Psychic = psychic;
export const Force = force;
export const Poison = poison;
export const Acid = acid;
export const Radiant = radiant;
export const Cold = cold;
export const Fire = fire;
export const Lightning = lightning;
export const Healing = healing;
export const Necrotic = necrotic;
export const Bludgeoning = bludgeoning;
export const Piercing = piercing;
export const Slashing = slashing;
export const Thunder = thunder;

export const Psychic_White = psychic_white;
export const Force_White = force_white;
export const Poison_White = poison_white;
export const Acid_White = acid_white;
export const Radiant_White = radiant_white;
export const Cold_White = cold_white;
export const Fire_White = fire_white;
export const Lightning_White = lightning_white;
export const Healing_White = healing_white;
export const Necrotic_White = necrotic_white;
export const Bludgeoning_White = bludgeoning_white;
export const Piercing_White = piercing_white;
export const Slashing_White = slashing_white;
export const Thunder_White = thunder_white;

// Dice
export const D20 = d20;
export const CritFail = crit_fail;
export const CritSuccess = crit_success;
export const D4 = d4;
export const D6 = d6;
export const D8 = d8;
export const D10 = d10;
export const D100 = d100;
export const D100_WHITE = d100_white;
export const D12 = d12;
export const D4_Black = d4_black;
export const D6_Black = d6_black;
export const D8_Black = d8_black;
export const D10_Black = d10_black;
export const D100_Black = d100_black;
export const D12_Black = d12_black;

// Other
export const Circle = circle;
export const Voice_white = voice_white;
